import "./tokens-details.css";
import { getUserNameFromStoreData } from "../../../utils";
import { useTokensDetailHook } from "./useTokensDetailHook";

const TokensDetails = () => {
  const {
    tokens,
    isLoading,
    setSearchTerm,
    setRecordCount,
    auth,
    filterHandler,
    recordCount
  } = useTokensDetailHook();

  return (
    <div className="container mt-4">
      <h4 className="text-success  mb-4">
        {getUserNameFromStoreData(auth)} VALID TOKEN(S) DETAIL
      </h4>
      <hr />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <label htmlFor="entries" className="form-label me-2 fw-bolder">
            Show
          </label>
          <select
            id="entries"
            onChange={(e) => setRecordCount(e.target.value)}
            className="form-select d-inline-block w-auto"
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="ms-2 fw-bolder">entries</span>
        </div>
        <div>
          <label htmlFor="search" className="form-label me-2 fw-bolder">
            Search:
          </label>
          <input
            id="search"
            onChange={(e) => setSearchTerm(e.target.value)}
            type="text"
            className="form-control d-inline-block w-auto"
          />
        </div>
      </div>
      {isLoading && (
        <div className="loader-wrapper">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
      )}

      {!isLoading && (
        <div className="table-responsive">
          <table className="table table-bordered custom-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Token Generated Date</th>
                <th>Status</th>
                <th>Generated Token</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              {tokens
                .filter(filterHandler)
                .slice(0, recordCount)
                .map((token) => (
                  <tr key={token.no}>
                    <td>{token.no}</td>
                    <td>{token.date || "—"}</td>
                    <td className="text-success fw-bold">ACTIVE</td>
                    <td>WJCW CF-{token.token}</td>
                    <td>{token.fee}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TokensDetails;
